<template>
  <div v-loading="loading" class="page-form page-base">
    <h3 class="title">高端总经销生产计划</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        disabled
        label-width="100px"
        :model="conditions"
        :show-message="false"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="生产计划编号">
              <el-input v-model="conditions.prodpl_id" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="prodpl_type" label="单据类型">
              <el-input value="高端总经销生产计划" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="sold_to" label="订单客户">
              <el-input v-model="conditions.sold_to" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="name_soldto" label="订单客户名称">
              <el-input v-model="conditions.name_soldto" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户">
              <el-input v-model="conditions.name_billto" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select v-model="conditions.soldto_type" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item prop="contactor" label="联系方式">
              <el-input v-model="conditions.contactor" />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item prop="sals_center" label="营销单元">
              <el-select v-model="conditions.sals_center" placeholder="" :disabled="selectDataOptions.orgList && selectDataOptions.orgList.length === 1" clearable>
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="预约">
              <el-checkbox v-model="conditions.preorder" true-label="1" false-label="0" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="conditions.address"
                type="textarea"
                rows="2"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                type="textarea"
                rows="2"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="制单人">
              <el-input v-model="conditions.uname" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="部门">
              <el-input v-model="conditions.dept_name" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="conditions.datum"
                type="date"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-input v-model="conditions.status" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="生产计划单项目" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'medium' }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <template #filename="{ row }">
            <span class="blue" @click="downLoadFile(row)">{{ row.filename }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('history')">
        <vxe-grid
          ref="history"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>
    </div>
  </div>
</template>
<script>
import { apiGetProdDetail } from '@/api/sap/make-plan'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { sapDownloadFile } from '@/utils/frontExport'
import { apiSapClientFindInfo } from '@/api/common'

export default {
  data() {
    return {
      conditions: {
        prodpl_id: '',
        prodpl_type: 'ZPD3',
        sold_to: '',
        name_soldto: '',
        bill_to: '',
        name_billto: '',
        contactor: '',
        address: '',
        preorder: '',
        soldto_type: '',
        sals_center: '',
        datum: '',
        uname: '',
        status: '新建',
        remark: '',
        dept_name: ''
      },
      selectDataOptions: {
        orgList: []
      },
      loading: false,
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          {
            field: 'prodpl_item',
            title: '行号',
            width: 50,
            formatter: ({ cellValue }) => Number(cellValue)
          },
          {
            field: 'prod_id',
            title: '产品编号',
            width: 180
          },
          {
            field: 'description',
            title: '描述',
            width: 180
          },
          {
            field: 'wlybrand',
            title: '品牌',
            width: 180
          },
          {
            field: 'planqty_box',
            title: '数量（件）',
            width: 120
          },
          {
            field: 'planqty_bottle',
            title: '数量（瓶）',
            width: 120
          },
          {
            field: 'planqty_ton',
            title: '数量（吨）',
            width: 120
          },
          {
            field: 'area',
            title: '区域',
            width: 180
          },
          {
            field: 'abclv',
            title: '优先级',
            width: 180
          },
          {
            field: 'alv_box',
            title: '可用总量（件）',
            width: 180
          },
          {
            field: 'purmat_qty',
            title: '采购中数量（件）',
            width: 180
          },
          {
            field: 'pur_date',
            title: '采购到货日期',
            width: 180
          },
          {
            field: 'remark',
            title: '备注',
            width: 180
          }
        ],
        data: []
      },
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          { field: 'filename', title: '附件名', width: 'auto' },
          { field: 'doc_type', title: '附件类型', width: 'auto' },
          { field: 'filelength', title: '附件大小', width: 'auto' },
          { field: 'zzfld00002d', title: '上传人', width: 'auto' },
          { field: 'zzfld00002d_dscr', title: '上传人姓名', width: 'auto' },
          { field: 'created_date', title: '上传日期', width: 'auto' },
          { field: 'created_time', title: '上传时间', width: 'auto' }
        ],
        data: []
      },
      gridOptionsHistory: {
        columns: [
          { field: 'zzfld00000u', title: '操作人', width: 'auto' },
          { field: 'zzfld000031', title: '操作人姓名', width: 'auto' },
          { field: 'zzfld00000v', title: '状态', width: 'auto' },
          { field: 'zzfld00000w', title: '变更日期', width: 'auto' },
          { field: 'zzfld00000x', title: '变更时间', width: 'auto' },
          { field: 'zzfld000092', title: '拒绝原因', width: 'auto' }
        ],
        data: []
      }
    }
  },
  created() {
    // 生产计划单据类型
    this.getSelectDictDataOrigin('A0006')
    // 客户类型
    this.getSelectDictDataOrigin('A0009')
    this.getSelectDictDataOrigin('A0008')
    this.getSelectDictDataOrigin('level')
    this.queryData()
  },
  methods: {
    cellClassName({ column }) {
      return column.params?.bgEdit ? 'cell--bg--edit' : 'cell--bg--default'
    },
    async queryData() {
      const { head, item, button } = await apiGetProdDetail({ prodpl_id: this.$route.query.id, user_bp: this.role.USER_BP })
      Object.assign(this.conditions, head)
      this.initCustome()
      this.gridOptions.data = item
      this.buttons = button
      if (button.edit) {
        this.formDis = true
      }
    },
    // 查询客户信息
    async initCustome() {
      const params = { rt_partner: [{
        SIGN: 'I',
        OPTION: 'EQ',
        LOW: this.conditions.sold_to,
        HIGH: ''
      }], page: 1, pagesize: 50 }
      // 当前登录账号和角色
      params.partner = this.role.USER_BP
      params.role = this.role.ROLE
      const { data } = await apiSapClientFindInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data[0].high_yxdy)
    },
    // 文件下载
    downLoadFile(row) {
      sapDownloadFile(row.xcontent, row.filename)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          const rows = response.data.Rows.filter(item => item.value !== 'ZPD3')
          this.$set(this['selectDataOptions'], dictcode, rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 10px;
  text-align: left;
  position: relative;
  .btn-header {
    background: #fff;
    position: fixed;
    transform: translate(-10px, -10px);
    z-index: 99;
    width: calc(100% - 273px);
    height: 50px;
    padding: 5px 0 0 10px;
    box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.5);
  }
}
.blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/make-plan-manage/components/hightendMakePlanOrderCheck.vue